import * as Types from "@zapier/reporting/src/graphql-types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type LogStreamsPermissionQueryVariables = Types.Exact<{
  accountId: Types.Scalars["ID"]["input"];
}>;

export type LogStreamsPermissionQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    permissions: { __typename?: "Permissions"; canAccessLogStreams: boolean };
  } | null;
};

export const LogStreamsPermissionDocument = gql`
  query LogStreamsPermission($accountId: ID!) {
    currentUser {
      permissions(accountId: $accountId) {
        canAccessLogStreams
      }
    }
  }
`;

/**
 * __useLogStreamsPermissionQuery__
 *
 * To run a query within a React component, call `useLogStreamsPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogStreamsPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogStreamsPermissionQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useLogStreamsPermissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    LogStreamsPermissionQuery,
    LogStreamsPermissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LogStreamsPermissionQuery,
    LogStreamsPermissionQueryVariables
  >(LogStreamsPermissionDocument, options);
}
export function useLogStreamsPermissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogStreamsPermissionQuery,
    LogStreamsPermissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LogStreamsPermissionQuery,
    LogStreamsPermissionQueryVariables
  >(LogStreamsPermissionDocument, options);
}
export type LogStreamsPermissionQueryHookResult = ReturnType<
  typeof useLogStreamsPermissionQuery
>;
export type LogStreamsPermissionLazyQueryHookResult = ReturnType<
  typeof useLogStreamsPermissionLazyQuery
>;
export type LogStreamsPermissionQueryResult = Apollo.QueryResult<
  LogStreamsPermissionQuery,
  LogStreamsPermissionQueryVariables
>;
